export function faqToItem({ question, answer }) {
  return { title: question, content: answer }
}

/**
 * @param {{question: string, answer: string}[]} faqs
 * @return {string}
 */
export function faqsToSchema(faqs) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs?.map(({question, answer}) => ({
      '@type': 'Question',
      name: `${question}`,
      acceptedAnswer: {
        '@type': 'Answer',
        text: `${answer}`,
      },
    })),
  }
  return JSON.stringify(schema)
}
